import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export interface ProductPrice {
  id: number;
  product_id: string;
  quantity: number;
  original_price: number;
  sale_price: number;
  discount_rate: number;
  created_at: string;
  updated_at: string;
}

export function useProductPrices(productId: string | undefined) {
  const [prices, setPrices] = useState<ProductPrice[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!productId) {
      setPrices([]);
      return;
    }

    const fetchPrices = async () => {
      setLoading(true);
      setError(null);

      try {
        const { data, error } = await supabase
          .from('product_prices')
          .select('*')
          .eq('product_id', productId)
          .order('quantity', { ascending: true });

        if (error) {
          throw error;
        }

        setPrices(data || []);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch prices');
        setPrices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPrices();
  }, [productId]);

  return { prices, loading, error };
}

// Price calculation utility functions by quantity
export const formatPrice = (price: number): string => {
  return price.toLocaleString('en-US');
};

export const calculateSavings = (originalPrice: number, salePrice: number): number => {
  return originalPrice - salePrice;
};

export const calculateDiscountRate = (originalPrice: number, salePrice: number): number => {
  return Math.round(((originalPrice - salePrice) / originalPrice) * 100);
};